import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SalledeclasseProfileLayout from './SalledeclasseProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import SalledeclasseService from '../../services/SalledeclasseService';
import PersonnelService from '../../services/PersonnelService';

const ViewSalledeclasse = () => {
	const { id } = useParams();
	const [salledeclasse, setSalledeclasse] = useState(null);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [personnelOptions, setPersonnelOptions] = useState([]);
	const [selectedPersonnel, setSelectedPersonnel] = useState('');

	useEffect(() => {
		Promise.all([SalledeclasseService.getSalledeclasse(id)]).then(
			([salledeclasseData]) => {
				setSalledeclasse(salledeclasseData.data);

				if (salledeclasseData && salledeclasseData.data) {
					const enseignant = salledeclasseData.data.personnel;
					setSelectedPersonnel(enseignant);
				}
			}
		);
	}, [id]);

	useEffect(() => {
		const fetchClassOptions = async () => {
			try {
				const personnels = await PersonnelService.getEnseignantOptions();
				setPersonnelOptions(personnels);
			} catch (error) {
				console.error('Error fetching personnel options', error);
			}
		};

		fetchClassOptions();
	}, []);

	const PERSONNEL_CHOICES = personnelOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const salledeclasseData = new FormData();

				// // Add all your form data to the FormData
				// salledeclasseData.append('personnel', form.personnel.value);

				// Call the AnneescolaireService to create the year
				const response = await SalledeclasseService.updateSalledeclasse(
					id,
					salledeclasseData
				);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					'Erreur lors de la mise à jour des informations de la salle de classe',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<SalledeclasseProfileLayout>
			{salledeclasse && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}

								<Row>
									{/* Enseignant */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="personnel">
												Enseignant <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="personnel"
												required
												value={selectedPersonnel}
												isInvalid={!!feedbackMessages['personnel']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedPersonnel(value);
												}}
											>
												<option value="">
													Selectionner un(e) enseignant(e)
												</option>
												{PERSONNEL_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['personnel']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Mettre à jour
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</SalledeclasseProfileLayout>
	);
};

export default ViewSalledeclasse;
